import * as React from 'react';
/**
 *
 * Original name: auto split clip
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=47351%3A1803
 *
 */
export const AutoSplitClipPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M28 7h4v5h-4V7Zm0 9h4v5h-4v-5Zm4 9h-4v5h4v-5Zm-4 9h4v5h-4v-5Zm4 9h-4v5h4v-5Zm-4 9h4v5h-4v-5Zm-4-2H9v-4h11V18H9v-4h15v36Zm27-4v4H36V22h1.86c.57 0 1.11.22 1.51.63.41.4.63.94.63 1.51V46h11Zm5-32v4h-1.86c-1.63 0-3.19.65-4.34 1.8a6.139 6.139 0 0 0-1.8 4.34V26h-4v-1.86c0-1.63-.65-3.19-1.8-4.34a6.139 6.139 0 0 0-4.34-1.8H36v-4h1.86c1.63 0 3.19-.65 4.34-1.8A6.139 6.139 0 0 0 44 7.86V6h4v1.86c0 1.63.65 3.19 1.8 4.34a6.139 6.139 0 0 0 4.34 1.8H56Z", fill: "currentColor" })));
